import React from "react";
import { Link } from "react-router-dom";

export default function Logo({ className = "" }) {
  return (
    <Link to="/" className={`font-display text-xl md:text-2xl tracking-wide leading-none select-none ${className}`}>
      <span className="text-white">ALWAYS-</span>
      <span className="text-neon neon-glow">N</span>
      <span className="text-white">-ANYTIME</span>
    </Link>
  );
}
